import { router } from '@/_routing';
import MutationTypes from '@/stores/MutationTypes';
import ActionTypes from '@/stores/ActionTypes';

const exports = {};
export default exports;


// -- Auth ------

exports.isAuthenticated = () => {
  return !!require('@/stores/AppStore').default.getters.isAuthenticated;
};

exports.getBackendToken = () => {
  return require('@/stores/AppStore').default.state.auth.backendToken;
};

exports.getGitlabToken = () => {
  return require('@/stores/AppStore').default.getters.backendTokenClaims.token;
};

exports.login = () => {
  if (exports.isAuthenticated()) {
    require('@/stores/AppStore').default.commit(MutationTypes.LOGOUT);
  }
  router.push('/login');
};

exports.init = () => require('@/stores/AppStore').default.dispatch(ActionTypes.SETUP_KEEPALIVE);


// -- Prefs ------

exports.getUserPref = (k) => {
  return require('@/stores/AppStore').default.state.prefs[k];
};
